import styled from 'styled-components';
import { pxtorem } from '~/utils/tools';

export const StyledBenefits = styled.div`
  padding: 50px 20px;

  figure {
    margin: 0;
    border-radius: 12px;
    overflow: hidden;

    & img {
      border-radius: 12px;
    }
  }

  h3 {
    font-size: ${pxtorem(40)};
    font-weight: 300;
    line-height: 1;
    margin: 0 0 1em;
  }

  .tagline {
    display: none;
  }

  p {
    font-size: ${pxtorem(16)};
    line-height: 1.125;
  }

  .mediaContent {
    --borderColor: rgba(255, 255, 255, 0.2);

    ul {
      list-style-type: none;
      margin: ${pxtorem(36)} 0;
      border-top: 1px solid var(--borderColor);
    }

    li {
      display: flex;
      border-bottom: 1px solid var(--borderColor);
      padding: 20px 0 23px;
      line-height: 1.2;

      em,
      strong {
        display: block;
        font-weight: 500;
        margin-right: ${pxtorem(40)};
      }
    }
  }

  @media (min-width: 768px) {
    /* padding: 20px 20px 90px 80px; */

    display: flex;
    gap: 40px;

    article,
    figure {
      flex: 1;
      gap: 40;
    }

    h3 {
      font-size: ${pxtorem(60)};
      margin: 100px 0 10px;
    }

    .tagline {
      display: block;
      font-size: ${pxtorem(16)};
      margin: 0 0 1em;
      text-transform: uppercase;
    }

    p {
      font-size: ${pxtorem(20)};
    }

    ul {
      font-size: ${pxtorem(20)};
    }
  }
`;
